export default class PageAgeGate extends Core.SectionComponent {
  onSelect() {
    const ageGate = Core.Components.getComponent('age-gate-page');

    if (!ageGate) return;
    
    ageGate.open();
  }

  onDeselect() {
    const ageGate = Core.Components.getComponent('age-gate-page');
    
    if (!ageGate) return;

    ageGate.close();
  }
}
